export const AUTO_SYNC_OPTIONS = [
  {
    label: 'label.DEFAULT',
    value: null
  },
  {
    label: 'label.MERGE_AND_DO_NOT_REPLACE_PARAMS',
    value: false
  },
  {
    label: 'label.MERGE_AND_REPLACE_PARAMS',
    value: true
  }
];
